import MerchantDocumentCard from '@/components/landing/cards/Merchant/Document/MerchantDocument'
import {
  legalMerchantDocuments,
  realMerchantDocuments
} from '@/data/landing/MerchantDocument'
import Tabs from '@dgshahr/ui-kit/Tabs'
import { ReactElement, useRef, useState } from 'react'

function RequiredDocs() {
  const [activeKey, setActiveKey] = useState<number>(1)
  const animationTimeoutRef = useRef<NodeJS.Timeout | null>(null)
  const tabContentContainerRef = useRef<HTMLDivElement | null>(null)

  const tabsContent: Record<number, ReactElement[]> = {
    1: realMerchantDocuments.map((document) => (
      <MerchantDocumentCard key={document.id} {...document} />
    )),
    2: legalMerchantDocuments.map((document) => (
      <MerchantDocumentCard key={document.id} {...document} />
    ))
  }

  const handleTabChange = (key: number | string) => {
    if (animationTimeoutRef.current) {
      clearTimeout(animationTimeoutRef.current)
    }

    const contentElementRef = tabContentContainerRef.current
    if (contentElementRef) {
      contentElementRef.classList.add('opacity-0')

      animationTimeoutRef.current = setTimeout(() => {
        setActiveKey(key as number)
        contentElementRef.classList.remove('opacity-0')
        contentElementRef.scrollLeft = 0
        animationTimeoutRef.current = null
      }, 200)
    } else {
      setActiveKey(key as number)
    }
  }

  return (
    <section className="w-full py-10 tablet:py-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 tablet:px-6 desktop:px-8">
        <div className="mb-8 text-center">
          <div className="mb-3 inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-600">
            مدارک مورد نیاز
          </div>
          <h2 className="text-2xl font-black text-slate-900 tablet:text-3xl">
            مدارک لازم برای ثبت‌نام فروشنده
          </h2>
        </div>

        <div className="flex flex-col items-center justify-center">
          <Tabs
            activeKey={activeKey}
            items={[
              {
                key: 1,
                title: 'حقیقی'
              },
              {
                key: 2,
                title: 'حقوقی'
              }
            ]}
            onChange={handleTabChange}
          />

          <div className="mt-6 w-full rounded-[28px] border border-slate-200 bg-slate-50/80 p-3 tablet:p-6">
            <div
              ref={tabContentContainerRef}
              className="scrollbar-hidden overflow-x-auto pb-1 transition-opacity duration-200 ease-in-out"
            >
              <div className="mx-auto flex w-max min-w-full justify-center gap-3">
                {tabsContent[activeKey]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default RequiredDocs
